import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'fetch-polyfill'
import 'whatwg-fetch'
import 'custom-event-polyfill'
import 'babel-polyfill'
import promise from 'es6-promise'
promise.polyfill()
import Vue from 'vue'
// import '@/utils/check-browser-version'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import { request } from './utils/request'
import './assets/iconfonts/icons/iconfont.css'
import './assets/iconfonts/menuIcons/iconfont.css'
import './assets/jifeniconfont/iconfont.css'
import './assets/huifuiconfont/iconfont.css'
import ECharts from 'vue-echarts'
import chinaJson from 'echarts/map/json/china'
import { addAttrInBody } from './utils/browser'
import LkUi from 'link-eai-ui'
import 'link-eai-ui/lib/link-eai-ui.css'
// 导入数据字典
import '@/common/dict'
import 'vue-draggable-resizable-gorkys/dist/VueDraggableResizable.css'

import '@/directives'
import '@/mixin/global_burying_point.mixin'

// TODO:认证相关
import oidc from '@/utils/oidc'
oidc()
addAttrInBody()
Vue.use(ElementUI)

Vue.component('v-chart', ECharts)
ECharts.registerMap('china', chinaJson)
// message相关
import message from '@/utils/message'
message()

// 引入微前端数据通信模块
import '@/shared/actions'
// with polyfills
// import 'core-js/stable'
// import 'regenerator-runtime/runtime'
// import 'fetch-polyfill'

// 禁用全局loading，如需使用请使用指令形式的loading
Vue.prototype.$loading = function() {
  return {
    close: function() {}
  }
}

// 将网络请求传入基础组件里面
Vue.use(LkUi, {
  request,
  empty: require('@/assets/images/table-no-data.png')
})

import eventiframe from '@/utils/eventiframe'
eventiframe()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
